import { PermissionManagement } from "@/components/PermissionManagement";
import { PermissionGate } from "@/components/PermissionGate";

/**
 * Permission management page
 * Only accessible to users with manage_settings permission
 */
export default function PermissionManagementPage() {
  return (
    <PermissionGate
      permission="manage_settings"
      fallback={
        <div className="flex flex-col items-center justify-center h-[70vh]">
          <h1 className="text-2xl font-bold mb-4">Access Denied</h1>
          <p className="text-gray-600">
            You don't have permission to access this page.
          </p>
        </div>
      }
    >
      <PermissionManagement />
    </PermissionGate>
  );
}
